module.exports = __webpack_public_path__ + "static/img/14.be9a1ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/14.png
// module id = f9fP
// module chunks = 0